import forEach from 'lodash.foreach';
import lSportsService from '../../../services/lSportsService';

export const SET_EVENTS = '[APP] SET EVENTS';
export const SET_PREMATCH_EVENTS = '[APP] SET PREMATCH EVENTS';
export const SET_PREMATCH_LEAGUE_EVENTS = '[APP] SET PREMATCH LEAGUE EVENTS';
export const UPDATE_PREMATCH_RMQ_EVENT = '[APP] UPDATE PREMATCH RMQ EVENT';

export const UPDATE_EVENTS = '[APP] UPDATE EVENTS';
export const ON_SEARCH = '[APP] ON SEARCH';
export const ON_CLEAR_SEARCH = '[APP] ON CLEAR SEARCH';
export const ON_MAIN_MARKET_SELECTED = '[APP] ON MAIN MARKET SELECTED';
export const ON_SPORT_SELECTED = '[APP] ON SPORT SELECTED';
export const ON_LOCATION_SELECTED = '[APP] ON LOCATION SELECTED';
export const ON_LEAGUE_SELECTED = '[APP] ON LEAGUE SELECTED';
export const SET_ACTIVE_MATCH_ID = '[APP] SET ACTIVE MATCH ID';

export const SET_LOCATIONS_ACTIVE = '[APP] SET LOCATIONS ACTIVE';
export const SET_PREMATCH_ACTIVE = '[APP] SET PREMATCH ACTIVE';

export const START_LOADING = '[APP] START LOADING';
export const ON_REMOVE_LEAGUE = '[APP] ON REMOVE LEAGUE';
export const SET_SPORT_SEARCH_ACTIVE = '[APP] SET SPORT SEARCH ACTIVE';

export const selectMainMarket = (sportId, marketId) => {
    return (dispatch, getState) => {
        dispatch({
            type: ON_MAIN_MARKET_SELECTED,
            sportId: sportId,
            marketId: marketId,
        });
    };
};

export const selectSport = (sportId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_SPORT_SELECTED, sportId: sportId });
    };
};

export const selectLocation = (locationId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_LOCATION_SELECTED, locationId: locationId });
    };
};

export const selectLeague = (leagueId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_LEAGUE_SELECTED, leagueId: leagueId });
    };
};

export const setActiveMatchId = (matchId) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_ACTIVE_MATCH_ID, matchId: matchId });
    };
};

export const setLocationsActive = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_LOCATIONS_ACTIVE, value: value });
    };
};

export const setPrematchActive = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_PREMATCH_ACTIVE, value: value });
    };
};

export const setSportSearchActive = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_SPORT_SEARCH_ACTIVE, value: value });
    };
};

export const setEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_EVENTS, events: events });
    };
};

export const updateEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: UPDATE_EVENTS, events: events });
    };
};

export const updatePrematchRMQEvent = (event) => {
    return (dispatch, getState) => {
        dispatch({ type: UPDATE_PREMATCH_RMQ_EVENT, event: event });
    };
};

export const search = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_SEARCH, search: value });
    };
};

export const clearSearch = () => {
    return (dispatch, getState) => {
        dispatch({ type: ON_CLEAR_SEARCH });
    };
};

export const removeLeague = (sportId, locationId, leagueId) => {
    return (dispatch, getState) => {
        dispatch({
            type: ON_REMOVE_LEAGUE,
            sportId: sportId,
            locationId: locationId,
            leagueId: leagueId,
        });
    };
};

export const startLoading = (desiredLoadCount) => {
    return (dispatch, getState) => {
        dispatch({ type: START_LOADING, desiredLoadCount: desiredLoadCount });
    };
};

export const setPrematchEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_PREMATCH_EVENTS, events: events });
    };
};

export const prematchSetLeagueEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_PREMATCH_LEAGUE_EVENTS, events: events });
    };
};

export const prematchGetLeagueEvents = (sportId, locationId, leagueId) => {
    return (dispatch, getState) => {
        lSportsService
            .prematchGetLeagueEvents(sportId, locationId, leagueId)
            .then((events) => {
                dispatch(prematchSetLeagueEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const prematchLoadEventsInChunks = (data) => {
    return (dispatch, getState) => {
        forEach(data, (sport) => {
            forEach(sport.Locations, (location) => {
                forEach(location.Leagues, (league) => {
                    dispatch(prematchGetLeagueEvents(sport.Id, location.Id, league.Id));
                });
            });
        });
    };
};

export const prematchGetAllEvents = () => {
    return (dispatch, getState) => {
        lSportsService
            .prematchGetEvents(1)
            .then((events) => {
                dispatch(setPrematchEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const getEvents = (lang) => {
    return (dispatch, getState) => {
        lSportsService
            .prematchGetEvents(0)
            .then((events) => {
                dispatch(prematchGetAllEvents());
                dispatch(setPrematchEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export function mapLSportsPrematchDispatchToProps(dispatch) {
    return {
        prematch: {
            getEvents: (lang) => {
                dispatch(getEvents(lang));
            },
            search: (value) => {
                dispatch(search(value));
            },
            clearSearch: () => {
                dispatch(clearSearch());
            },
            selectMainMarket: (sportId, marketId) => {
                dispatch(selectMainMarket(sportId, marketId));
            },
            setActiveMatchId: (matchId) => {
                dispatch(setActiveMatchId(matchId));
            },
            selectSport: (sportId) => {
                dispatch(selectSport(sportId));
            },
            selectLocation: (locationId) => {
                dispatch(selectLocation(locationId));
            },
            selectLeague: (leagueId) => {
                dispatch(selectLeague(leagueId));
            },
            setLocationsActive: (value) => {
                dispatch(setLocationsActive(value));
            },
            setPrematchActive: (value) => {
                dispatch(setPrematchActive(value));
            },
            startLoading: (desiredLoadCount) => {
                dispatch(startLoading(desiredLoadCount));
            },
            removeLeague: (sportId, locationId, leagueId) => {
                dispatch(removeLeague(sportId, locationId, leagueId));
            },
            setSportSearchActive: (value) => {
                dispatch(setSportSearchActive(value));
            },
            updateEvents: (events) => {
                dispatch(updateEvents(events));
            },
            updatePrematchRMQEvent: (event) => {
                dispatch(updatePrematchRMQEvent(event));
            },
        },
    };
}
